import isEqual from 'lodash/isEqual'

import { SET_DESTROYED, SET_FETCHED } from './actions'

const LOOKUP_METADATA = {
  contacts: 'handle',
  public_contacts: 'handle',
  badges: 'type',
}

export function api(state = {}, action) {
  switch (action.type) {
    case SET_FETCHED:
      if (!action.records) {
        return state
      }

      return insertRecords(state, action.records)

    case SET_DESTROYED:
      return destroyRecords(state, action)

    default:
      return state
  }
}

function insertRecords(state, records) {
  for (const modelName in records) {
    if (records.hasOwnProperty(modelName)) {
      const recordsAsArray = Object.values(records[modelName].data)
      const previousState = state && state[modelName] && state[modelName].data
      const [recordsToInsert, lookup] = getChangedRecordsAsLookup(
        previousState,
        modelName,
        recordsAsArray,
      )

      if (recordsToInsert) {
        state = {
          ...state,
          [modelName]: {
            ...state[modelName],
            data: {
              ...(state[modelName] && state[modelName].data),
              ...recordsToInsert,
            },
            lookup: {
              ...(state[modelName] && state[modelName].lookup),
              ...lookup,
            },
          },
        }
      }
    }
  }
  return state
}

function getChangedRecordsAsLookup(previousState, modelName, records) {
  const lookup = {}
  const data = records.reduce((data, record) => {
    if (hasRecordChanged(previousState, record, modelName)) {
      data[record.id] = record
      if (modelName in LOOKUP_METADATA) {
        const key = LOOKUP_METADATA[modelName]
        lookup[record[key]] = record.id
      }
    }
    return data
  }, {})

  const isEmptyObject = !Object.keys(data).length
  return isEmptyObject ? [null, null] : [data, lookup]
}

function hasRecordChanged(previousState, record, modelName) {
  return true
  // const prevRecord = previousState?.[record.id]
  // /*
  //   exception for topics, the participants attribute is injected through has_dependent_models on the server.
  //   A more thorough way of fixing this is to insert into a lookup when inserting topics into reduxes. (see LOOKUP_METADATA in the js code)
  //   We will also need to allow lambdas and merging under the same key in the LookupService on the rails side (used for the preload data)
  //  */
  // if (modelName === 'topics' && prevRecord) {
  //   if (!isEqual(prevRecord.participants, record.participants)) {
  //     return true
  //   }
  // }
  //
  // const previousUpdatedAt =
  //   prevRecord?.updated_at && new Date(prevRecord?.updated_at)
  //
  // const nextUpdatedAt = record.updated_at && new Date(record.updated_at)
  //
  // if (!previousUpdatedAt || !nextUpdatedAt) {
  //   return true
  // }
  //
  // // handle new keys getting added to the as_json
  // const prevNoOfKeys = Object.keys(prevRecord).length
  // const nextNoOfKeys = Object.keys(record).length
  //
  // return previousUpdatedAt < nextUpdatedAt || prevNoOfKeys !== nextNoOfKeys
}

function destroyRecords(state, action) {
  const ids = Array.isArray(action.id) ? action.id : [action.id]
  ids.forEach((id) => {
    const { [id]: _, ...newState } = state[action.modelName]?.data || {}
    state = {
      ...state,
      [action.modelName]: {
        ...state[action.modelName],
        data: newState,
      },
    }
  })
  return state
}
